import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  magicLink: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  thankYou: {
    marginTop: '5vh',
    maxWidth: '550px',
    margin: 'auto',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  headingBox: { textAlign: 'center' },
  userEmail: { color: '#8DA8B2' },
}));

type Props = {
  userEmail: string;
};

const SentVerificationBanner = ({ userEmail }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.headingBox}>
      <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
      <img src={'/magic-link.svg'} alt="Trustate Products" className={classes.magicLink} />
      <div className={classes.thankYou}>
        <Typography variant="h4" style={{ marginBottom: '15px' }}>
          Thank you!
        </Typography>
        <Typography>
          We've sent an email to <span className={classes.userEmail}>{userEmail}</span> with a
          verification link and code.
        </Typography>{' '}
      </div>
    </div>
  );
};

export default SentVerificationBanner;
